<template>
  <div>
    <b-row>
      <b-col md="3">
        <h6>No Label</h6>
        <hr />
        <McRadioButton
          v-model="selectedValue"
          id="radio1"
          :name="'component-radio'"
          :initialValue="true"
        />
      </b-col>
      <b-col md="3">
        <h6>Label</h6>
        <hr />
        <McRadioButton
          v-model="selectedValue"
          id="radio2"
          :label="label"
          :name="'component-radio'"
          :initialValue="false"
        />
      </b-col>
    </b-row>
    <b-row class="mt-5">
      <b-col md="3">
        <h6>Disabled</h6>
        <hr />
        <McRadioButton
          v-model="selectedValue"
          id="radio3"
          disabled
          :name="'component-radio-disabled'"
          :initialValue="true"
        />
      </b-col>
      <b-col md="3">
        <h6>Disabled</h6>
        <hr />
        <McRadioButton
          v-model="selectedValue"
          id="radio4"
          :label="label"
          disabled
          :name="'component-radio-disabled'"
          :initialValue="false"
        />
      </b-col>
    </b-row>

    <b-row class="mt-5">
      <b-col md="3">
        <h6>OnChange</h6>
        <hr />
        <McRadioButton
          v-model="selectedValue"
          @change="onChange"
          id="radio5"
          :name="'component-radio-change'"
          :initialValue="true"
        />
      </b-col>
      <b-col md="3">
        <h6>OnChange</h6>
        <hr />
        <McRadioButton
          v-model="selectedValue"
          @change="onChange"
          id="radio6"
          :label="label"
          :name="'component-radio-change'"
          :initialValue="false"
        />
      </b-col>
    </b-row>
  </div>
</template>

<script>
import McRadioButton from './index.vue'

export default {
  components: {
    McRadioButton,
  },
  props: {
    label: {
      type: String,
    },
  },
  data() {
    return {
      selectedValue: false,
    }
  },
  methods: {
    onChange() {
      alert('onChange')
    },
  },
}
</script>

<style lang="scss"></style>
